module.exports = __webpack_public_path__ + "img/header-weddingRingsFrameSettings.14ccbfa.webp";